import { Auth0Client, Auth0ClientOptions } from '@auth0/auth0-spa-js';
import { ROUTES } from '../constants';

const defaultAuth0Config: Auth0ClientOptions = {
  domain: window.__env__.SAGEID_ENVIRONMENT,
  clientId: window.__env__.SAGEID_CLIENT_ID,
  authorizationParams: {
    audience: window.__env__.SAGEID_CLIENT_AUDIENCE || undefined,
    redirect_uri: `${window.location.origin}${ROUTES.SAGE_ID_SIGN_IN_TRIGGER}`,
    scope: window.__env__.SAGEID_CLIENT_SCOPE
  },
  cacheLocation: 'localstorage'
};

const auth0Config: Auth0ClientOptions = window.auth0?.auth0Config || defaultAuth0Config;

// Reuse the shell's existing Auth0Client so we inherit its authenticated session.
// Only create a new client if one hasn't been set up yet (e.g. standalone mode).
const auth0Client = window.auth0?.auth0Client ?? new Auth0Client(auth0Config);

window.auth0 = {
  ...window.auth0,
  auth0Config,
  auth0Client
};

export { auth0Client, auth0Config };
